import { IPaginationParams, IPaginationResponse } from 'interfaces/pagination';
import { IVenture } from 'interfaces/venture';
import * as rxjs from 'rxjs';
import RxOp from 'rxjs-operators';
import { distinctUntilChanged } from 'rxjs/operators';

import apiService, { ApiService } from './api';
import selectedVentureService from './profile';

export class VentureService {
  private ventures$: rxjs.BehaviorSubject<number>;

  constructor(private apiService: ApiService) {
    this.ventures$ = new rxjs.BehaviorSubject(0);
  }

  public list(params: IPaginationParams): rxjs.Observable<IPaginationResponse<IVenture>> {
    return this.apiService.get('/venture', params, false).pipe(
      RxOp.tap((next) => next && 'total' in next && this.ventures$.next(next.total))
    );
  }

  public save(model: IVenture): rxjs.Observable<IVenture> {
    const response = this.apiService.post('/venture', model, false);

    return response.pipe(
      RxOp.tap(() => model.id ?
        this.ventures$.next(this.ventures$.value) :
        this.ventures$.next(this.ventures$.value + 1)
      )
    );
  }

  public delete(id: number): rxjs.Observable<void> {
    return this.apiService.delete(`/venture/${id}`).pipe(
      RxOp.tap(() => this.ventures$.next(this.ventures$.value - 1))
    );
  }

  public getById(venture: IVenture | number): rxjs.Observable<IVenture> {
    return this.apiService.get(`/venture/${typeof venture === 'object' ? venture.id : venture}`, undefined, false);
  }

  public refreshVenture() {
    return selectedVentureService
      .getSelectedVenture()
      .subscribe(selection => {
        if (selection && selection.id) {
          ventureService.getById(selection.id).subscribe();
        }
      });
  }

  public getVenturesCount(): rxjs.Observable<number> {
    return this.ventures$.pipe(distinctUntilChanged());
  }
}

const ventureService = new VentureService(apiService);
export default ventureService;